export function getFilterDropdownValues<T extends Record<string, string> | string = string>(
  options: string[] | T[] | null,
  mapping?: Record<string, string>,
  labelKey: string = 'label',
  valueKey: string = 'value'
): Array<{
  id: number;
  label: string;
  value: string;
  isGroup: boolean;
  groupName: string;
}> {
  if (!options) return [];

  return options.map((option, index) => {
    if (typeof option === 'string') {
      return {
        id: index,
        label: mapping?.[option] ?? option,
        value: option,
        isGroup: false,
        groupName: ''
      };
    }

    return {
      id: index,
      label: option[labelKey],
      value: option[valueKey],
      isGroup: false,
      groupName: ''
    };
  });
}
